import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

interface G2ReviewAccessTokenResponse {
  reviewExists: boolean;
  accessToken?: string;
}

export const useGetG2ReviewAccessToken = (params?: { enabled?: boolean }) => {
  const enabled = params?.enabled ?? true;
  return useQuery({
    queryKey: ['g2ReviewAccessToken'],
    queryFn: async () => {
      const { data } = await api.get<{ data: G2ReviewAccessTokenResponse }>(
        `/api/core/g2-app/get-access-token`,
      );
      return data.data;
    },
    enabled,
  });
};
